import { render, staticRenderFns } from "./ViewGenresTags.vue?vue&type=template&id=1c4ba068"
import script from "./ViewGenresTags.vue?vue&type=script&lang=js"
export * from "./ViewGenresTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports